import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';

import { InactivityTimer } from '../lib/inactivity-timer';

export type InactivityTimerContextValue = Omit<InactivityTimer, 'init' | 'destroy'>;

export const InactivityTimerContext = createContext<InactivityTimerContextValue | null>(null);

export function InactivityTimerProvider({ children }: { children: ReactNode }) {
    const [inactivityTimer] = useState(() => new InactivityTimer());

    useEffect(() => {
        inactivityTimer.init();
        return () => inactivityTimer.destroy();
    }, [inactivityTimer]);

    return <InactivityTimerContext value={inactivityTimer}>{children}</InactivityTimerContext>;
}

export function useInactivityTimer() {
    const context = useContext(InactivityTimerContext);

    if (!context) {
        throw new Error('useInactivityTimer must be used within InactivityTimerProvider');
    }

    return context;
}
